export default "__VITE_ASSET__CNa85Lu8__"